import React, { useState } from 'react';
import {
    Container,
    Paper,
    Typography,
    TextField,
    Button,
    Box,
    Snackbar,
    FormControlLabel,
    Switch
} from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../Auth/AuthProvider';
import { can } from '../../Conections/LogConections';
import { SetBonoCreate } from '../../Conections/AcademicConection';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function BonoCreate() {

    const goTo = useNavigate();
    const { getToken, getCompany } = useAuth();
    const params = useParams();

    const [nombre, setNombre] = useState('');
    const [peso, setPeso] = useState('');
    const [mostrar, setMostrar] = useState(true);
    const [error, setError] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);

    React.useEffect(() => {
        async function reloaduser() {
            if (getToken()) {
                const permisionCan = await can(getToken(), getCompany(), "/academic/createbono/:activity");
                if (permisionCan === 0) {
                    goTo("/dashboard");
                }
            }
            else {
                goTo(`/login`);
            }
        };
        reloaduser();
    }, [getCompany, getToken, goTo]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!nombre.trim() || !peso.trim()) {
            setError('Por favor, complete todos los campos.');
            return;
        }
        if (isNaN(peso) || Number(peso) <= 0) {
            setError('El peso debe ser un número positivo.');
            return;
        }
        const datos = await SetBonoCreate(
            getToken(),
            getCompany(),
            params["activity"],
            nombre,
            peso,
            mostrar?1:0
        );
        goTo("/academic/showactivity/" + datos);
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    return (
        <Container component="main" maxWidth="sm">
            <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
                <Typography component="h1" variant="h5" align="center" gutterBottom>
                    Crear Nuevo Bono
                </Typography>
                <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="nombre"
                        label="Nombre del Bono"
                        name="nombre"
                        autoFocus
                        value={nombre}
                        onChange={(e) => setNombre(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="peso"
                        label="Peso del Bono"
                        type="number"
                        id="peso"
                        value={peso}
                        onChange={(e) => setPeso(e.target.value)}
                        inputProps={{ min: "0", step: "0.1" }}
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={mostrar}
                                onChange={(e) => setMostrar(e.target.checked)}
                                name="mostrar"
                                color="primary"
                            />
                        }
                        label="Mostrar Bono"
                    />
                    {error && (
                        <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                            {error}
                        </Typography>
                    )}
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        Crear Bono
                    </Button>
                </Box>
            </Paper>
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
                    Bono creado exitosamente!
                </Alert>
            </Snackbar>
        </Container>
    );
}

export default BonoCreate;
